import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';
import * as types from './types';

export const userMutations = {
  [types.Users.SET.ALL](state, payload) {
    state.userlist = payload;
  },
  [types.SelectedUser.SET.SINGLE](state, payload) {
    console.log('userDetails', payload)
    state.userDetails = payload;
  },
  ...implementSetAllNavTabDetailsMutation(types.UserDetails, 'userDetails')
};